<template>
  <div class="misc-wrapper">
    <!-- Brand logo-->
    <b-link class="brand-logo">
      <b-img
        :src="appLogoImageUrl"
        rounded="circle"
        alt="logo"
      />
    </b-link>
    <!-- /Brand logo-->

    <div class="misc-inner p-2 p-sm-3">
      <div
        class="p-75 text-center"
      >
        <h2 class="mb-1">
          {{ $t('full.login-problem') }} 😢
        </h2>
        <p class="mb-2">
          {{ $t('full.logout_subtitle') }}
        </p>
        <b-button
          variant="primary"
          class="mb-1"
          block
          @click="logout"
        >{{ $t('full.logout-clear') }}</b-button>
        <b-button
          type="submit"
          variant="outline-primary"
          block
          href="./.auth/purge/aad"
        >
          <b-img
            class="mr-75"
            :src="require('@/assets/images/icons/microsoft.svg')"
          />
          <span class="align-middle">{{ $t('full.logout_microsoft') }}</span>
        </b-button>

        <b-button
          type="submit"
          variant="outline-primary"
          block
          href="./.auth/purge/google"
        >
          <b-img
            class="mr-75"
            :src="require('@/assets/images/icons/google.svg')"
          />
          <span class="align-middle">{{ $t('full.logout_google') }}</span>
        </b-button>
      </div>
      <div class="w-100 text-center">
        <b-img
          fluid
          :src="imgUrl"
          alt="Logout page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import store from '@/store/index'
import authService from '@/vue.auth.service'

const { appName, appLogoImageUrl } = $themeConfig.app

export default {
  components: { BLink, BImg, BButton },
  data() {
    return {
      appName,
      appLogoImageUrl,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return require('@/assets/images/pages/coming-soon-dark.svg')
      } return require('@/assets/images/pages/coming-soon.svg')
    },
  },
  methods: {
    logout() {
      authService.logout(true)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';

.p-75{
margin-left: 12.5%;
margin-right: 12.5%;
}
</style>
